// import find from 'lodash/find';
// import throttle from 'lodash/throttle';
import 'pages/questions/components/missing_questions';
import 'pages/questions/components/question';
import 'pages/questions/components/question_belt';
import 'pages/questions/components/questions_feedback';
import './index.scss';

class QuestionsList {
  constructor($component) {
    this.$component = $component;
    this.$pagination = $('.js-pagination');
    // this.questionListFocusClass = 'q-questions-list--focused';
    // this.questionItemFocusClass = 'q-question-item--focused';

    this._setInitialState();
    this._bindQuestionItems();
    // this._bindKeyboard();
    // this._bindClickOut();
    // this._bindAlternativeChanges();
    // TODO: Define new keyboard shortcuts that not causes collateral effects for users.
  }

  // _scrollTo($element) {
  //   $('html, body').stop().animate({
  //     scrollTop: $element.offset().top - 40
  //   }, 300);
  // }

  _setInitialState() {
    const $questionItems = $('.js-question-item', this.$component);

    this.state = {
      currentAlternatives: [],
      currentPage: Number(this.$component.data('current-page')),
      questionsPerPage: Number(this.$component.data('per-page')),
      showResolvedFeedback:
        this.$component.data('show-resolved-feedback') !== false,
      hasNextQuestion: !!$questionItems.length,
      hasPrevQuestion: false,
      isFocused: false,
      isFirstAction: true,
      isQuestionSelected: false,
      isAlternativeSelected: false,
      $currentQuestion: null,
      $prevQuestion: null,
      $nextQuestion: $questionItems.first()
    };
  }

  // _bindKeyboard() {
  //   $('body').on('keyup', e => {
  //     if (e.shiftKey) {
  //       switch (e.keyCode) {
  //         case 38:
  //           this._call('prev');
  //           break; // [Arrow Up] Navigate Up
  //         case 40:
  //           this._call('next');
  //           break; // [Arrow Down] Navigate Down
  //         case 37:
  //           this._call('paginate', 'prev');
  //           break; // [Arrow Left] Pagination Prev
  //         case 39:
  //           this._call('paginate', 'next');
  //           break; // [Arrow Right] Pagination Next
  //         default: {
  //           if (!this.state.isFocused) return;
  //
  //           // [Num 1-7] Toggle Tabs
  //           if (e.keyCode >= 49 && e.keyCode <= 55) this._call('toggleQuestionTab', e.keyCode - 49);
  //           // [Enter] Answer
  //           else if (e.keyCode === 13) this._call('answerQuestion');
  //           // [A-E] Check Alternative
  //           else {
  //             const alternative = find(this.state.currentAlternatives, {keyCode: e.keyCode});
  //             if (alternative) this._call('selectAlternative', alternative);
  //           }
  //         }
  //       }
  //     } else if (this.state.isFocused && e.keyCode === 13) { // [Enter] Answer without press Shift
  //       this._call('answerQuestion');
  //     }
  //   });
  // }

  // _call(action, param) {
  //   if (!window.isTurbolinksLoading) throttle(() => this[action](param), 1500)();
  // }

  _bindQuestionItems() {
    $('.js-question-item', this.$component).each((i, el) => {
      const $questionItem = $(el);
      this.renderQuestionIndex($questionItem, i);
      this.renderQuestionLabel($questionItem);
    });
  }

  // _bindClickOut() {
  //   $(window).on('click', e => {
  //     if (this.state.isFocused)
  //       if (!$(e.target).closest(this.state.$currentQuestion).length) {
  //         this.blurQuestion();
  //       }
  //   });
  // }

  // _bindAlternativeChanges() {
  //   $('.js-question-answer', this.$component).on('change', e => {
  //     if (!e.currentTarget.checked) return;
  //     this.state.$currentQuestion = $(e.currentTarget).parents('.js-question-item');
  //     this.state.isFocused = true;
  //   });
  // }

  // toggleQuestionsListFocus() {
  //   if (this.state.isFocused) {
  //     this.$component.addClass(this.questionListFocusClass);
  //     this.state.$currentQuestion.removeClass(this.questionItemFocusClass);
  //   } else {
  //     this.$component.removeClass(this.questionListFocusClass);
  //   }
  // }

  // setCurrentAlternatives() {
  //   this.state.currentAlternatives = $('.js-question-answer', this.state.$currentQuestion)
  //     .toArray()
  //     .map(el => {
  //       return {
  //         $input: $(el),
  //         alternative: el.value.toLowerCase(),
  //         keyCode: el.value.charCodeAt(0)
  //       };
  //     });
  // }

  // focusQuestion($questionItem) {
  //   $('.js-question-item', this.$component).removeClass(this.questionItemFocusClass);
  //   this.state.$currentQuestion = $questionItem;
  //
  //   this.state.$prevQuestion = $questionItem.prev('.js-question-item');
  //   this.state.$nextQuestion = $questionItem.next('.js-question-item');
  //   this.state.hasPrevQuestion = !!this.state.$prevQuestion.length;
  //   this.state.hasNextQuestion = !!this.state.$nextQuestion.length;
  //   this.state.isFocused = !!$questionItem.length;
  //   this.state.isAlternativeSelected = false;
  //   this.state.isFirstAction = false;
  //
  //   this.toggleQuestionsListFocus();
  //   this.setCurrentAlternatives();
  //
  //   this.state.$currentQuestion.addClass(this.questionItemFocusClass).focus();
  // }

  // blurQuestion() {
  //   this.$component.removeClass(this.questionListFocusClass);
  //   this.state.$currentQuestion.removeClass(this.questionItemFocusClass);
  //   this._setInitialState();
  // }

  // prev() {
  //   if (this.state.isFirstAction) return this.next();
  //   if (!this.state.hasPrevQuestion) return;
  //   this._scrollTo(this.state.$prevQuestion);
  //   this.focusQuestion(this.state.$prevQuestion);
  // }

  // next() {
  //   if (!this.state.hasNextQuestion) return;
  //   this._scrollTo(this.state.$nextQuestion);
  //   this.focusQuestion(this.state.$nextQuestion);
  // }

  // paginate(direction) {
  //   const $current = $('.page.current', this.$pagination);
  //   const $target = $current[direction]('.page');
  //   if (!$target.length) return;
  //   const url = $target.find('a').attr('href');
  //   Turbolinks.visit(url);
  // }

  // selectAlternative(alternative) {
  //   alternative.$input.prop('checked', true).trigger('change');
  //   this.state.isAlternativeSelected = true;
  // }
  //
  // answerQuestion() {
  //   $('.js-answer-btn', this.state.$currentQuestion).trigger('click');
  // }

  // toggleQuestionTab(tabIndex) {
  //   const $questionBeltTabs = $('.q-question-belt-tabs a', this.state.$currentQuestion);
  //   const $tab = $($questionBeltTabs[tabIndex]);
  //   const tabContentId = $tab.attr('href');
  //   this._scrollTo($tab);
  //
  //   if ($tab.parent().hasClass('active')) {
  //     $('.js-tab-close', tabContentId).trigger('click');
  //   } else {
  //     $tab.tab('show');
  //   }
  // }

  renderQuestionIndex($questionItem, index) {
    $('.js-question-index', $questionItem)
      .html((index + 1) + (this.state.currentPage - 1) * this.state.questionsPerPage)
      .addClass('visible');
  }

  renderQuestionLabel($questionItem) {
    const status = $questionItem.data('status');
    const correct = $questionItem.data('correct');

    // "Exibir se acertei ou errei anteriormente" (user_practice_preferences).
    if (status === 'resolved' && !this.state.showResolvedFeedback) {
      return;
    }

    const modifier = status === 'resolved' ?
      correct ? 'correct' : 'wrong' :
      status === 'nullified' ? 'nullified' : 'outdated';

    const icon = status === 'resolved' ?
      correct ? 'check-circle' : 'times-circle' :
      status === 'nullified' ? 'info-circle' : 'exclamation-circle';

    const caption = status === 'resolved' ?
      correct ? 'Resolvi certo!' : 'Resolvi errado!' :
      status === 'nullified' ? 'Questão anulada' : 'Questão desatualizada';

    if (status !== 'unsolved') {
      const html = `
        <label class="q-question-label q-question-label--${modifier}">
          <div class="q-caption">
            <i class="q-icon q-icon-${icon}"></i>
            <span>${caption}</span>
          </div>
        </label>`;

      $('.js-question-label', $questionItem).html(html);
    }
  }
}

(function () {
  'use strict';

  const $questionsList = $('.js-questions-list');
  if (!$questionsList.length) return;
  const el = $questionsList.get(0);
  if (!el.questionListInstance) el.questionListInstance = new QuestionsList($questionsList);
})();
